// `web` marks the banner's web-app-only link, which may also be a site path (/studio).
export default function AdLinkBadge({ link, web = false }) {
    if (!link) {
        return (
            <div style={{
                display: 'inline-flex', alignItems: 'center', gap: 4,
                fontSize: 10, padding: '2px 6px', borderRadius: 4,
                background: '#f3f4f6', color: '#9ca3af', marginTop: 4,
            }}>
                <span>🚫 sem link (não clicável)</span>
            </div>
        );
    }

    const isExternal = /^https?:\/\//i.test(link);
    const isDeeplink = link.startsWith('app://');
    const isWebPath = web && link.startsWith('/');
    const valid = isExternal || isDeeplink || isWebPath;
    const label = !valid ? '⚠️ inválido' : web ? '💻 só web' : isExternal ? '🌐 URL' : '📱 deeplink';
    const bg = !valid ? '#fee2e2' : web ? '#ede9fe' : isExternal ? '#dbeafe' : '#dcfce7';
    const color = !valid ? '#991b1b' : web ? '#5b21b6' : isExternal ? '#1e40af' : '#166534';

    return (
        <div
            style={{
                display: 'inline-flex', alignItems: 'center', gap: 4, maxWidth: '100%',
                fontSize: 10, padding: '2px 6px', borderRadius: 4,
                background: bg, color, marginTop: 4, overflow: 'hidden',
            }}
            title={link}
        >
            <span style={{ flexShrink: 0 }}>{label}</span>
            <span style={{
                fontFamily: 'monospace', overflow: 'hidden', textOverflow: 'ellipsis',
                whiteSpace: 'nowrap', fontSize: 10,
            }}>
                {link}
            </span>
        </div>
    );
}
